import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "comment_small.svg",
  "use": "comment_small.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"comment_small.svg\"><path d=\"M7.5 8C7.22386 8 7 8.22386 7 8.5V13.5C7 13.7761 7.22386 14 7.5 14H9.5C9.77614 14 10 14.2239 10 14.5V15.7929C10 16.2383 10.5386 16.4614 10.8536 16.1464L12.8536 14.1464C12.9473 14.0527 13.0745 14 13.2071 14H16.5C16.7761 14 17 13.7761 17 13.5V8.5C17 8.22386 16.7761 8 16.5 8H7.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol